import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20digital%20illustration%20of%20a%20modern%20online%20entertainment%20platform%2C%20colorful%20abstract%20geometric%20shapes%20floating%2C%20warm%20orange%20and%20coral%20gradient%20background%2C%20playful%20and%20energetic%20atmosphere%2C%20digital%20art%20style%2C%20clean%20minimalist%20composition%2C%20soft%20glowing%20elements&width=1800&height=900&seq=hero-bg-onlinelu&orientation=landscape"
        alt="在线撸平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
          随时随地<span className="text-orange-400">在线撸</span>的极致体验
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          无需下载、即点即玩，汇聚海量在线撸内容——撸视频、撸猫、撸串、撸铁、撸代码、撸题，
          六大板块满足你的所有在线撸需求，立即开启轻松有趣的线上之旅！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/video"
            className="px-8 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-full transition-all duration-300 text-sm whitespace-nowrap"
          >
            立即体验 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-semibold rounded-full backdrop-blur-sm transition-all duration-300 text-sm whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-10 flex items-center justify-center gap-6 text-white/60 text-xs">
          <span className="flex items-center gap-1"><i className="ri-check-line text-green-400"></i> 无需下载</span>
          <span className="flex items-center gap-1"><i className="ri-check-line text-green-400"></i> 即点即玩</span>
          <span className="flex items-center gap-1"><i className="ri-check-line text-green-400"></i> 内容海量</span>
          <span className="flex items-center gap-1"><i className="ri-check-line text-green-400"></i> 每日更新</span>
        </div>
      </div>
    </section>
  );
}